"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultVaultsAPI = exports.encodeVault = void 0;
const big_js_1 = __importDefault(require("big.js"));
const utils_1 = require("../utils");
const collateral_1 = require("./collateral");
const oracle_1 = require("./oracle");
const issue_1 = require("./issue");
const redeem_1 = require("./redeem");
const replace_1 = require("./replace");
const fee_1 = require("./fee");
const transaction_1 = require("./transaction");
function encodeWallet(wallet, network) {
    const { addresses, public_key } = wallet;
    const btcAddresses = [];
    for (const value of addresses.values()) {
        btcAddresses.push(utils_1.encodeBtcAddress(value, network));
    }
    return {
        publicKey: public_key.toString(),
        addresses: btcAddresses,
    };
}
function encodeVault(vault, network) {
    const { wallet } = vault, obj = __rest(vault, ["wallet"]);
    return Object.assign({
        wallet: encodeWallet(wallet, network),
    }, obj);
}
exports.encodeVault = encodeVault;
class DefaultVaultsAPI extends transaction_1.DefaultTransactionAPI {
    constructor(api, btcNetwork, account) {
        super(api, account);
        this.granularity = 5;
        this.btcNetwork = btcNetwork;
        this.collateralAPI = new collateral_1.DefaultCollateralAPI(api);
        this.oracleAPI = new oracle_1.DefaultOracleAPI(api);
        this.feeAPI = new fee_1.DefaultFeeAPI(api);
    }
    register(planckCollateral, publicKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = this.api.tx.vaultRegistry.registerVault(planckCollateral, publicKey);
            yield this.sendLogged(tx, this.api.events.vaultRegistry.RegisterVault);
        });
    }
    withdrawCollateral(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            const amountAsPlanck = this.api.createType("Collateral", utils_1.dotToPlanck(amount.toString()));
            const tx = this.api.tx.vaultRegistry.withdrawCollateral(amountAsPlanck);
            yield this.sendLogged(tx, this.api.events.vaultRegistry.WithdrawCollateral);
        });
    }
    lockAdditionalCollateral(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            const amountAsPlanck = this.api.createType("Collateral", utils_1.dotToPlanck(amount.toString()));
            const tx = this.api.tx.vaultRegistry.lockAdditionalCollateral(amountAsPlanck);
            yield this.sendLogged(tx, this.api.events.vaultRegistry.LockAdditionalCollateral);
        });
    }
    list() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const vaultsMap = yield this.api.query.vaultRegistry.vaults.entriesAt(head);
            return vaultsMap
                .map((v) => encodeVault(v[1], this.btcNetwork));
        });
    }
    mapIssueRequests(vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const issueRequestPairs = yield this.api.rpc.issue.getVaultIssueRequests(vaultId);
                return new Map(issueRequestPairs.map(([id, req]) => [id, issue_1.encodeIssueRequest(req, this.btcNetwork)]));
            }
            catch (err) {
                return Promise.reject(`Error during issue request retrieval: ${err}`);
            }
        });
    }
    mapRedeemRequests(vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const redeemRequestPairs = yield this.api.rpc.redeem.getVaultRedeemRequests(vaultId);
                return new Map(redeemRequestPairs.map(([id, req]) => [id, redeem_1.encodeRedeemRequest(req, this.btcNetwork)]));
            }
            catch (err) {
                return Promise.reject(`Error during redeem request retrieval: ${err}`);
            }
        });
    }
    mapReplaceRequests(vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const oldVaultReplaceRequests = yield this.api.rpc.replace.getOldVaultReplaceRequests(vaultId);
                const oldVaultReplaceRequestsExt = oldVaultReplaceRequests.map(([id, req]) => [id, replace_1.encodeReplaceRequest(req, this.btcNetwork)]);
                const newVaultReplaceRequests = yield this.api.rpc.replace.getNewVaultReplaceRequests(vaultId);
                const newVaultReplaceRequestsExt = newVaultReplaceRequests.map(([id, req]) => [id, replace_1.encodeReplaceRequest(req, this.btcNetwork)]);
                return new Map([...oldVaultReplaceRequestsExt, ...newVaultReplaceRequestsExt]);
            }
            catch (err) {
                return Promise.reject(`Error during replace request retrieval: ${err}`);
            }
        });
    }
    get(vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const vault = yield this.api.query.vaultRegistry.vaults.at(head, vaultId);
            if (!vaultId.eq(vault.id)) {
                throw new Error(`No vault registered with id ${vaultId}`);
            }
            return encodeVault(vault, this.btcNetwork);
        });
    }
    getLiquidationVaultId() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const liquidationVaultId = yield this.api.query.vaultRegistry.liquidationVaultAccountId.at(head);
            return liquidationVaultId.toString();
        });
    }
    getLiquidationVault() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const liquidationVault = yield this.api.query.vaultRegistry.liquidationVault.at(head);
            return liquidationVault;
        });
    }
    isNoTokensIssuedError(e) {
        return e.message.includes("NoTokensIssued");
    }
    getVaultCollateralization(vaultId, newCollateral, onlyIssued = false) {
        return __awaiter(this, void 0, void 0, function* () {
            let collateralization = undefined;
            try {
                if (newCollateral) {
                    const newCollateralPlanck = this.api.createType("Collateral", utils_1.dotToPlanck(newCollateral.toString()));
                    collateralization = yield this.api.rpc.vaultRegistry.getCollateralizationFromVaultAndCollateral(vaultId, this.wrapCurrency(newCollateralPlanck), onlyIssued);
                }
                else {
                    collateralization = yield this.api.rpc.vaultRegistry.getCollateralizationFromVault(vaultId, onlyIssued);
                }
            }
            catch (e) {
                if (this.isNoTokensIssuedError(e)) {
                    return Promise.resolve(undefined);
                }
                return Promise.reject(`Error during collateralization computation: ${e.message}`);
            }
            if (!collateralization) {
                return Promise.resolve(undefined);
            }
            return new big_js_1.default(utils_1.decodeFixedPointType(collateralization));
        });
    }
    getSystemCollateralization() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const collateralization = yield this.api.rpc.vaultRegistry.getTotalCollateralization();
                return new big_js_1.default(utils_1.decodeFixedPointType(collateralization));
            }
            catch (e) {
                if (this.isNoTokensIssuedError(e)) {
                    return Promise.resolve(undefined);
                }
                return Promise.reject("Error during collateralization computation");
            }
        });
    }
    getRequiredCollateralForVault(vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const dotWrapper = yield this.api.rpc.vaultRegistry.getRequiredCollateralForVault(vaultId);
                return new big_js_1.default(utils_1.planckToDOT(this.unwrapCurrency(dotWrapper).toString()));
            }
            catch (e) {
                return Promise.reject(e.message);
            }
        });
    }
    getRequiredCollateralForWrapped(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const amountSat = this.api.createType("BalanceWrapper", utils_1.btcToSat(amount.toString()));
                const dotWrapper = yield this.api.rpc.vaultRegistry.getRequiredCollateralForWrapped(amountSat);
                return new big_js_1.default(utils_1.planckToDOT(this.unwrapCurrency(dotWrapper).toString()));
            }
            catch (e) {
                return Promise.reject(e.message);
            }
        });
    }
    getIssuedAmount(vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            const vault = yield this.get(vaultId);
            return new big_js_1.default(utils_1.satToBTC(vault.issued_tokens.toString()));
        });
    }
    getIssuedPolkaBTCAmounts() {
        return __awaiter(this, void 0, void 0, function* () {
            const vaults = yield this.list();
            const issuedTokens = vaults.map((v) => new big_js_1.default(utils_1.satToBTC(v.issued_tokens.toString())));
            return issuedTokens;
        });
    }
    getTotalIssuedPolkaBTCAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            const issuedTokens = yield this.getIssuedPolkaBTCAmounts();
            if (issuedTokens.length) {
                const sumReducer = (accumulator, currentValue) => accumulator.add(currentValue);
                return issuedTokens.reduce(sumReducer);
            }
            return new big_js_1.default(0);
        });
    }
    getIssuablePolkaBTC() {
        return __awaiter(this, void 0, void 0, function* () {
            const polkaBTCCapacityString = yield this.getPolkaBTCCapacity();
            const polkaBTCCapacityBig = new big_js_1.default(polkaBTCCapacityString);
            const issuedPolkaBTCSatoshiString = (yield this.getTotalIssuedPolkaBTCAmount()).toString();
            const issuedPolkaBTCString = utils_1.satToBTC(issuedPolkaBTCSatoshiString);
            const issuedPolkaBTCBig = new big_js_1.default(issuedPolkaBTCString);
            return polkaBTCCapacityBig.sub(issuedPolkaBTCBig).toString();
        });
    }
    getPolkaBTCCapacity() {
        return __awaiter(this, void 0, void 0, function* () {
            const totalLockedDot = yield this.collateralAPI.totalLocked();
            const oracle = new oracle_1.DefaultOracleAPI(this.api);
            const exchangeRate = yield oracle.getExchangeRate();
            const exchangeRateU128 = new big_js_1.default(exchangeRate);
            const secureCollateralThreshold = yield this.getSecureCollateralThreshold();
            return totalLockedDot.div(exchangeRateU128).div(secureCollateralThreshold).toString();
        });
    }
    selectRandomVaultIssue(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const amountSat = this.api.createType("Wrapped", utils_1.btcToSat(amount.toString()));
                // eslint-disable-next-line max-len
                const firstVaultWithSufficientCollateral = yield this.api.rpc.vaultRegistry.getFirstVaultWithSufficientCollateral(this.wrapCurrency(amountSat));
                return firstVaultWithSufficientCollateral;
            }
            catch (e) {
                return Promise.reject("Did not find vault with sufficient collateral");
            }
        });
    }
    selectRandomVaultRedeem(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            const amountSat = this.api.createType("Wrapped", utils_1.btcToSat(amount.toString()));
            try {
                const firstVaultWithSufficientTokens = yield this.api.rpc.vaultRegistry.getFirstVaultWithSufficientTokens(this.wrapCurrency(amountSat));
                return firstVaultWithSufficientTokens;
            }
            catch (e) {
                return Promise.reject("Did not find vault with sufficient locked BTC");
            }
        });
    }
    getPremiumRedeemVaults() {
        return __awaiter(this, void 0, void 0, function* () {
            const customAPIRPC = this.api.rpc;
            try {
                const vaults = yield customAPIRPC.vaultRegistry.getPremiumRedeemVaults();
                return new Map(vaults.map(([id, redeemableTokens]) => [id, new big_js_1.default(utils_1.satToBTC(this.unwrapCurrency(redeemableTokens).toString()))]));
            }
            catch (e) {
                return Promise.reject("Did not find vault below the premium redeem threshold");
            }
        });
    }
    getVaultsWithIssuableTokens() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const vaults = yield this.api.rpc.vaultRegistry.getVaultsWithIssuableTokens();
                return new Map(vaults.map(([id, issuableTokens]) => [id, new big_js_1.default(utils_1.satToBTC(this.unwrapCurrency(issuableTokens).toString()))]));
            }
            catch (e) {
                return Promise.reject("Did not find vault with issuable tokens");
            }
        });
    }
    getVaultsWithRedeemableTokens() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const vaults = yield this.api.rpc.vaultRegistry.getVaultsWithRedeemableTokens();
                return new Map(vaults.map(([id, redeemableTokens]) => [id, new big_js_1.default(utils_1.satToBTC(this.unwrapCurrency(redeemableTokens).toString()))]));
            }
            catch (e) {
                return Promise.reject("Did not find vault with redeemable tokens");
            }
        });
    }
    isVaultFlaggedForTheft(vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const theftReports = yield this.api.query.stakedRelayers.theftReports.at(head, vaultId);
            return theftReports.isEmpty;
        });
    }
    getLiquidationCollateralThreshold() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const threshold = yield this.api.query.vaultRegistry.liquidationCollateralThreshold.at(head);
            return new big_js_1.default(utils_1.decodeFixedPointType(threshold));
        });
    }
    getPremiumRedeemThreshold() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const threshold = yield this.api.query.vaultRegistry.premiumRedeemThreshold.at(head);
            return new big_js_1.default(utils_1.decodeFixedPointType(threshold));
        });
    }
    getSecureCollateralThreshold() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const threshold = yield this.api.query.vaultRegistry.secureCollateralThreshold.at(head);
            return new big_js_1.default(utils_1.decodeFixedPointType(threshold));
        });
    }
    getFeesWrapped(vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const stake = utils_1.decodeFixedPointType(yield this.api.query.wrappedVaultRewards.stake.at(head, vaultId));
            const rewardPerToken = utils_1.decodeFixedPointType(yield this.api.query.wrappedVaultRewards.rewardPerToken.at(head));
            const rewardTally = utils_1.decodeFixedPointType(yield this.api.query.wrappedVaultRewards.rewardTally.at(head, vaultId));
            const fees = utils_1.computeReward(new big_js_1.default(stake), new big_js_1.default(rewardPerToken), new big_js_1.default(rewardTally));
            return new big_js_1.default(utils_1.satToBTC(fees.toString()));
        });
    }
    getFeesCollateral(vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const stake = utils_1.decodeFixedPointType(yield this.api.query.collateralVaultRewards.stake.at(head, vaultId));
            const rewardPerToken = utils_1.decodeFixedPointType(yield this.api.query.collateralVaultRewards.rewardPerToken.at(head));
            const rewardTally = utils_1.decodeFixedPointType(yield this.api.query.collateralVaultRewards.rewardTally.at(head, vaultId));
            const fees = utils_1.computeReward(new big_js_1.default(stake), new big_js_1.default(rewardPerToken), new big_js_1.default(rewardTally));
            return new big_js_1.default(utils_1.planckToDOT(fees.toString()));
        });
    }
    getAPY(vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            const [feesPolkaBTC, feesDOT, lockedDOT] = yield Promise.all([
                yield this.getFeesWrapped(vaultId),
                yield this.getFeesCollateral(vaultId),
                yield this.collateralAPI.balanceLocked(vaultId),
            ]);
            return this.feeAPI.calculateAPY(feesPolkaBTC, feesDOT, lockedDOT);
        });
    }
    getSLA(vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const sla = yield this.api.query.sla.vaultSla.at(head, vaultId);
            return utils_1.decodeFixedPointType(sla);
        });
    }
    getMaxSLA() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const maxSLA = yield this.api.query.sla.relayerTargetSla.at(head);
            const maxSlaBig = new big_js_1.default(maxSLA.toString());
            const divisor = new big_js_1.default(Math.pow(10, utils_1.FIXEDI128_SCALING_FACTOR));
            return maxSlaBig.div(divisor).toString();
        });
    }
    /**
     * @returns Fee that a Vault has to pay if it fails to execute redeem or replace requests
     * (for redeem, on top of the slashed BTC-in-DOT value of the request). The fee is
     * paid in DOT based on the PolkaBTC amount at the current exchange rate.
     */
    getPunishmentFee() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const fee = yield this.api.query.fee.punishmentFee.at(head);
            return utils_1.decodeFixedPointType(fee);
        });
    }
    wrapCurrency(amount) {
        return {
            amount: this.api.createType("Text", amount.toString(10)),
        };
    }
    unwrapCurrency(wrappedBalance) {
        return this.api.createType("Balance", wrappedBalance.amount.toString());
    }
}
exports.DefaultVaultsAPI = DefaultVaultsAPI;
//# sourceMappingURL=vaults.js.map